import React from 'react';
import { motion } from 'framer-motion';
import { Zap } from 'lucide-react';

const ITRoles = ({
    title = "Roles We Help Businesses Hire",
    roles = []
}) => {
    return (
        <section className="py-24 bg-[#01014C]">
            <div className="container mx-auto px-6">
                <div className="max-w-3xl mx-auto text-center mb-16">
                    <h2 className="text-3xl md:text-4xl font-bold text-white syne text-center mb-4">
                        {title}
                    </h2>
                    <p className="text-blue-100/70 text-sm md:text-base leading-relaxed">
                        Highly-vetted technical, operational, and leadership profiles we place to accelerate your business growth.
                    </p>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                    {roles && roles.map((role, i) => (
                        <motion.div 
                            whileHover={{ scale: 1.03 }} 
                            key={i} 
                            className="p-8 bg-white/5 border border-white/10 rounded-[2rem] backdrop-blur-md group hover:bg-blue-600 transition-all flex flex-col justify-between"
                        >
                            <div>
                                <div className="w-12 h-12 bg-blue-500/20 rounded-full mb-6 flex items-center justify-center text-blue-400 group-hover:text-white group-hover:bg-white/20 transition-all">
                                    <Zap size={20} />
                                </div>
                                <h4 className="text-white font-bold text-sm leading-tight mb-3">
                                    {role.title}
                                </h4>
                            </div>
                            <p className="text-blue-100/60 text-xs leading-relaxed group-hover:text-white/80 transition-colors">
                                {role.description}
                            </p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ITRoles;